import { Loader2 } from 'lucide-react';

import AssignmentEndScreen from '../../AssignmentEndScreen/AssignmentEndScreen';
import { useParams, useSearchParams } from 'react-router-dom';
import { useCheckAssignmentAccess } from '../../../hooks';
import useAssignmentResultsRefetch from '../../../hooks/useAssignmentResultsRefetch';
import { shouldRevealSolutions } from '../../../utils';

export const AssignmentEndPage = () => {
  const { studentAssignmentId } = useParams();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');
  const showResult = searchParams.get('showResult') === '1';

  const { isLoading, isFetching, isFetchedAfterMount, assignmentData } =
    useAssignmentResultsRefetch(studentAssignmentId);

  // Check if the user has access to the assignment
  useCheckAssignmentAccess({ assignmentData });

  // Wait for a fetch that happened after mount before rendering the result screen. Otherwise we may
  // act on the stale cached status (shared with the taking screen) and wrongly bounce home.
  if (isLoading || isFetching || !isFetchedAfterMount) {
    return (
      <div className="flex h-dvh flex-1 items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden />
      </div>
    );
  }

  const {
    status,
    studentResponse,
    result,
    assignment: { thankYouScreen, name, endButtonText, questions } = {}
  } = assignmentData || {};

  return (
    <AssignmentEndScreen
      name={name}
      status={status}
      endButtonText={endButtonText}
      thankYouScreen={thankYouScreen}
      revealSolutions={shouldRevealSolutions(assignmentData)}
      firstQuestionId={studentResponse?.[0]?.questionId}
      totalQuestions={questions?.length || 0}
      endReasonCode={reason}
      result={result}
      openResult={showResult}
    />
  );
};
